<template>
  <div class="home">
    <!--欢迎，{{$store.getters.userName}}-->
    <div class="header">
      <div class="item">
        <div class="title">机械总数</div>
        <div class="num">{{gather.equipTotal}}</div>
        <div class="sta-gra">
          <img src="../../../assets/images/s1.png">
        </div>
        <div class="bottom">在线数量<span>{{gather.equipOnline}}</span></div>
      </div>
      <div class="item">
        <div class="title">检测总数</div>
        <div class="num">{{gather.examTotal}}</div>
        <div class="sta-gra">
          <img src="../../../assets/images/s2.png">
        </div>
        <div class="bottom">今日检测数量<span>{{gather.examToday}}</span></div>
      </div>
      <div class="item">
        <div class="title">告警总数</div>
        <div class="num">{{gather.alertTotal}}</div>
        <div class="sta-gra">
          <!--<img src="../../../assets/images/s3.png">-->
            <span style="background:#ed637b;width:68%;">已处警</span><span style="background:#968fd9;width:32%;">未处警</span>
        </div>
        <div class="bottom">今日告警数量<span>{{gather.alertToday}}</span></div>
      </div>
      <div class="item">
        <div class="title">达到Ⅲ类机械总数</div>
        <div class="num">{{gather.standard3}}</div>
        <div class="sta-gra">
          <img src="../../../assets/images/s4.png">
        </div>
        <div class="bottom">
          <div class="bc">Ⅱ类<span>{{gather.standard2}}</span></div>
          <div class="bc">Ⅰ类<span>{{gather.standard1}}</span></div>
        </div>
      </div>
    </div>
    <div class="detail">
      <div class="item">
        <div class="title">
          县区机械所有量排行
        </div>
        <div class="data">
          <div class="row row-header">
            <div class="seq">排名</div>
            <div class="place">县区</div>
            <div class="total">机械总数</div>
            <div class="qualified">合格数</div>
          </div>
          <div class="row" v-for="(item, index) in gather.placeSta" :key="index">
            <div class="seq">{{index+1}}</div>
            <div class="place" @click="refreshType(item.id)">{{item.place_name}}</div>
            <div class="total">{{item.total}}</div>
            <div class="qualified">{{item.qualified}}</div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="title">
          机械类型占比
        </div>
        <div class="data">
          <Form inline><FormItem>
            <RadioGroup v-model="query.place.id" type="button" @on-change="refreshType">
              <Radio :label="null">全部</Radio>
              <Radio v-for="(item,index) in placeData" :key="index" :label="item.id">{{item.place_name}}</Radio>
            </RadioGroup>
          </FormItem></Form>
          <div id="typepie">
              <!--<chart
                  :options="pie"
                  :init-options="{renderer:'canvas'}"
                  theme="light"
                  ref="pie"
                  autoresize />-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import iSta from '@/module/base/api/iSta'
  import { Ring } from '@antv/g2plot'
  var ser_data = []
  var ringPlot = null
export default {
  name: 'home',
  components: {
  },
  data() {
    return {
      query:{
        place:{id:null}
      },
      gather:{
        equipTotal:0,
        equipOnline:0,
        examTotal:0,
        examToday:0,
        alertTotal:0,
        alertToday:0,
        standard1:0,
        standard2:0,
        standard3:0,
        placeSta:[],
        typeSta:[]
      },
      placeData:[
      ],
    }
  },
  mounted() {
    this.dataInit()
  },
  destroyed() {
    ringPlot = null
  },
  methods: {
    dataInit() {
      iSta.gather().then(res => {
        this.gather = res
        this.placeData = res.placeSta
        this.initTypeData(res.typeSta)
      });
    },
    initTypeData(arr) {
      let genData = []
      let serData = []
      for (var i = 0; i < arr.length; i++) {
        genData.push(arr[i].type_name)
        serData.push({name:arr[i].type_name,value:arr[i].total})
      }
      ser_data = serData

      if (null != ringPlot) {
        ringPlot.destroy()
      }
      ringPlot = new Ring(document.getElementById('typepie'), {
        forceFit: true,
        title: {
          visible: true,
          text: '类型占比',
        },
        label: {visible: false},
        radius: 0.8,
        padding: 'auto',
        data: serData,
        angleField: 'value',
        colorField: 'name',
        legend:{
          position:'right-top',
          offsetY:30,
          formatter(type) {
            return type + '  ' + ser_data.find(e=>e.name == type).value
          },
        }
      });
      ringPlot.render();
      /*for (i in ringPlot) {
        if (typeof (ringPlot[i]) == 'function') {
          console.log(i)
        }
      }*/
    },
    refreshType(id) {
      if (id) {
        this.query.place.id = id
      }
      iSta.equipTypeSta(this.query).then(res => {
        this.initTypeData(res)
      });
    }
  }
}
</script>
<style scoped lang="less">
  .header{
    display: flex;
    justify-content: space-evenly;
    margin-top:10px;

    .item{
      background:#ffffff;
      border:1px solid #eaeaea;
      flex:1;
      padding:20px 20px 0;
      margin:0 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: stretch;
      width:calc(25% - 20px);

      .title{
        font-size:14px;
        color:#929292;
      }
      .num{
        font-size:30px;
        color:#272727;
      }
      .sta-gra{
        margin-top:14px;

        img{
          /*display: none;*/
          width:~"calc(100%)";
        }
          span{
              display: inline-block;
              text-align: center;
              color:#ffffff;
          }
      }
      .bottom{
        border-top:1px solid #eaeaea;
        font-size:14px;
        color:#484848;
        margin-top:14px;
        height:36px;
        line-height:36px;
        display: flex;

        span{
          margin-left:10px;
        }

        .bc{
          flex:1;

          span{
            margin-left:10px;
          }
        }
      }
    }
  }
  .detail{
    display: flex;
    justify-content: space-evenly;
    margin-top:20px;
    min-height:500px;

    .item{
      background:#ffffff;
      border:1px solid #eaeaea;
      flex:1;
      margin:0 10px;
      width:calc(50% - 20px);

      .title{
        font-size:16px;
        color:#1f1f1f;
        font-weight:700;
        line-height:56px;
        border-bottom:1px solid #eaeaea;
        padding-left:20px;
      }

      .data{
        padding:20px;

        .row-header{
          background: #fbfbfb;
          color:#484848 !important;
          font-weight:700;

          &>div.place{
            color:#484848 !important;
          }
        }
        .row{
          font-size:14px;
          line-height:38px;
          border-bottom:1px solid #eaeaea;
          display: flex;
          color:#666666;

          .seq{
            text-align:center;
            width:80px;
          }
          .place{
            text-align: left;
            color:#1890FF;
            flex:1;
            cursor:pointer;
          }
          .total{
            text-align:right;
            flex:1;
          }
          .qualified{
             text-align:right;
             flex:1;
            padding-right:10px;
           }
        }
      }
    }
  }
</style>
